<template>
  <header class="site-header">
    <!-- desktop header -->
    <div class="site-header__container site-header__container_desktop">
      <router-link tag="div" :to="{ name: 'Home' }" class="site-header__left">
        <img class="site-header__logo_big" src="../assets/mgmt_logo_big.svg" alt="Standard Model Management">
      </router-link>
      <div class="site-header__right">
        <nav class="site-header__nav">
          <ul class="site-header__links">
            <router-link
            class="site-header__link"
            active-class="site-header__link_active"
            v-for="(link, index) in links"
            :key="index"
            tag="li" 
            :to="{ name: link.name, params: link.params }">{{ link.title }}</router-link>
          </ul>
        </nav>
      </div>
    </div>
    <!-- mobile header -->
    <div class="site-header__container site-header__container_mobile">
      <router-link tag="div" :to="{ name: 'Home' }" class="site-header__left">
        <img class="site-header__logo_small" src="../assets/mgmt_logo_small.svg" alt="Standard Model Management">
      </router-link>
      <div class="site-header__right">
        <button class="site-header__btn">
          <img
            @click="isMenuShown = !isMenuShown"
            class="site-header__burger"
            src="../assets/burger_icon_closed.svg"
          >
        </button>
        <transition name="nav">
        <div
          class="mobile-nav"
          v-show="isMenuShown"
        >
          <img class="site-header__logo_small mobile-nav__logo" src="../assets/mgmt_logo_small.svg" alt="Standard Model Management">
          <button class="site-header__btn mobile-nav__btn">
            <img
              @click="isMenuShown = !isMenuShown"
              class="site-header__burger"
              src="../assets/burger_icon_opened.svg"
            >
          </button>
          <ul @click="isMenuShown = false" class="mobile-nav__links">
            <router-link
            class="mobile-nav__link"
            active-class="mobile-nav__link_active"
            v-for="(link, index) in links"
            :key="index"
            tag="li" 
            :to="{ name: link.name, params: link.params }">{{ link.title }}</router-link>
          </ul>
        </div>
        </transition>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  props: {
    links: {
      reqired: true,
      type: Array
    }
  },
  data() {
    return {
      isMenuShown: false
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/fonts";
@use "../styles/colors";

.site-header {
  display: flex;
  justify-content: center;
  padding: 25px 45px 0;
  &__container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 1064px;
    &_mobile {
      display: none;
    }
  }
  &__left {
    cursor: pointer;
  }
  &__logo {
    &_big {
      width: 407px;
    }
    &_small {
      width: 170px;
    }
  }
  &__btn {
    background-color: transparent;
    border: none;
  }
  &__burger {
    cursor: pointer;
    width: 24px;
    &_hidden {
      display: none;
    }
  }
  &__nav {
    &_hidden {
      display: none;
    }
  }
  &__links {
    display: flex;
    justify-content: space-between;
  }
  &__link {
    @include fonts.mo-med;
    font-size: 10px;
    text-transform: uppercase;
    transition: 200ms all ease;
    cursor: pointer;

    &:not(:first-child) {
      margin-left: 20px;
    }

    &:hover, &_active {
      color: colors.$gray99;
    }

  }
}

@media screen and (max-width: 767px) {
  .site-header {
    padding: 18px 12px 0;
    &__container {
      &_desktop {
        display: none;
      }
      &_mobile {
        display: flex;
      }
    }
  }
  .mobile-nav {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    z-index: 10;
    &_hidden {
      display: none;
    }
    &__logo {
      position: absolute;
      top: 18px;
      left: 12px;
    }
    &__btn {
      position: absolute;
      top: 18px;
      right: 12px;
    }
    &__links {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    &__link {
      @include fonts.ap-reg;
      font-size: 24px;
      text-transform: uppercase;
      &:not(:first-of-type) {
        margin-top: 40px;
      }
    }
  }
}

// mobile nav animation
.nav-enter, .nav-leave-to {
  opacity: 0;
}

.nav-enter-to, .nav-leave {
  opacity: 1;
}

.nav-enter-active, .nav-leave-active {
  transition: all 200ms ease;
}

</style>